<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        编辑检测项目
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="保存项目信息"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave"
        />
        <import-upload
          ref="fduploadsbxx"
          accept="xlsx,xls"
          :action="`${importUrl}`"
          success-alert-msg="导入成功"
          :on-success="handleImportSuccess"
          :on-error="handleImportFailure"
          class="u-inline-block u-mg-l-8"
        />
        <k-button
          btn-text="导入消防设备"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-import"
          plain
          @click="handlePreviewImport"
        />
        <k-button
          btn-text="新增消防设备"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleAddXfsb"
        />
        <k-button
          v-if="xmInfo.xmzt === 'DSC'"
          v-permission-element="'jcxm_scbg'"
          btn-text="生成报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="handleScbg()"
        />
        <k-button
          v-if="xmInfo.xmzt === 'DSC'"
          v-permission-element="'jcxm_scbg_ls'"
          btn-text="生成临时报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="handleSclsbg()"
        />
        <k-button
          v-if="lsbgFileId"
          btn-text="查看临时报告"
          :auth-type="false"
          type="primary"
          plain
          icon="kestrel-icon ki-file-pdf"
          :disabled="xmInfo.previewPdf"
          @click="(e)=>$utils.previewPdf(e,lsbgFileId,xmInfo)"
        >
          <i
            v-show="xmInfo.previewPdf"
            class="el-icon-loading"
          />
        </k-button>
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：仅tabs为主内容 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="xmInfo"
        >
          <update-xminfo
            ref="xmInfo"
            type="xmInfo"
            @updateXminfo="handleXminfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="实施规划"
          name="action"
        >
          <action-info
            ref="actionInfo"
            type="actionInfo"
            :xm-info="xmInfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="消防设备"
          name="xfsb"
        >
          <xfsb-list
            ref="xfsb"
            type="edit"
            :xm-info="xmInfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="检测项"
          name="jcxList"
        >
          <jcx-edit-list
            @updateJcx="updateJcx"
          />
        </el-tab-pane>
        <el-tab-pane
          label="检测点明细"
          name="jcdmx"
        >
          <jcdmx-list />
        </el-tab-pane>

      <!-- 页面主内容：仅tabs为主内容 End -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import updateXminfo from './updateXminfo.vue';
import xfsbList from './xfsbList.vue';
import jcxEditList from './jcxEditList.vue';
import jcdmxList from './jcdmxList.vue';
import actionInfo from './actionInfo.vue';
import { xmglService } from '../xmgl.service';
import { xfsbService } from '../xfsb/xfsb.service.js';
export default {
  name: 'EditPgxm',
  components: {
    updateXminfo,
    xfsbList,
    jcxEditList,
    jcdmxList,
    actionInfo
  },
  data () {
    return {
      loading: false, // 页面loading状态
      activeName: 'xmInfo',
      xmid: null,
      xmInfo: {}, // 项目信息
      lsbgFileId: null, // 临时报告文件id
      importUrl: null
    };
  },
  methods: {
    /**
     * @description: 维保项目信息处理
     * @return {*}
     * @param {*} data
     */
    handleXminfo (data) {
      this.xmInfo = data;
    },
    /**
     * @description: 保存项目信息
     * @return {*}
     */
    handleSave () {
      this.activeName = 'xmInfo';
      this.$refs.xmInfo.handleSave();
    },
    /**
     * @description: 新增建筑
     * @return {*}
     */
    handleAddJz () {
      this.activeName = 'wbjz';
      this.$refs.wbjzList.handleDialog('add', { dlType: 'add' });
    },
    /**
     * @description: 生成临时报告
     * @return {*}
     */
    handleSclsbg () {
      const _this = this;
      _this.loading = true;
      xmglService.sclsbg(_this.xmId)
        .then(rsp => {
          this.lsbgFileId = rsp.data.data;
          _this.$alert('临时报告生成成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
        })
        .catch(err => {
          _this.$alert('临时生成报告失败！', '提示', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {
            }
          });
          console.error('临时生成报告失败！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 生成报告
     * @return {*}
     */
    handleScbg () {
      const _this = this;
      _this.$confirm('是否确认生成报告？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          _this.loading = true;
          xmglService.scbg(_this.xmId)
            .then(rsp => {
              _this.$alert('报告生成成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                  // _this.closeNavTabAndTo({ name: 'xmglIndex', params: { isRefresh: true } }, true);
                }
              });
              _this.$refs.xmInfo.init();
              _this.closeNavTabAndTo({ name: 'viewXfjc', params: { xmId: _this.xmId } }, true);
            })
            .catch(err => {
              console.error('报告生成失败！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        })
        .catch(() => {});
    },
    /**
     * @description: 文件上传前处理
     * @return {*}
     */
    handlePreviewImport () {
      const _this = this;
      _this.activeName = 'xfsb';
      const h = this.$createElement;
      this.$confirm('提示', {
        title: '提示',
        message: h('div', [
          h('p', '1、请使用模板导入设备信息，表中数据均为必填信息。'),
          h('p', '2、为保证成功，请根据表中数据格式及字段顺序依次填写。'),
          h('span', { attrs: { class: 'u-text-primary u-pointer u-pd-t-4 u-inline-block' }, on: { click: _this.handleDownload } }, '下载模板')
        ]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          _this.submitUpload();
        }).catch(() => {
        });
    },
    /**
     * @description: 触发上传按钮
     * @return {*}
     */
    submitUpload () {
      this.$refs.fduploadsbxx.handleClick();
      // this.loading = true;
    },
    /**
     * @description: 点击下载
     * @param {*}
     * @return {*}
     */
    handleDownload () {
      this.loading = true;
      xfsbService.exportSbmbFile()
        .then((rsp) => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('设备模板下载出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 导入消防设备成功
     * @return {*}
     */
    handleImportSuccess () {
      this.loading = false;
      this.activeName = 'xfsb';
      this.$refs.xfsb.refreshSearch();
    },
    /**
     * @description: 导入消防设备失败
     * @return {*}
     */
    handleImportFailure (error) {
      const e = JSON.parse(error.message);
      this.loading = false;
      this.activeName = 'xfsb';
      this.$alert(e.errorMsg, '提示', {
        confirmButtonText: '确定',
        type: 'error',
        callback: () => {
        }
      });
      this.$refs.xfsb.refreshSearch();
    },
    handleAddXfsb () {
      this.activeName = 'xfsb';
      this.$refs.xfsb.handleDialog('add');
    },
    updateJcx (data) {
      if (data.yjcxs && data.yjcxs >= 0) {
        this.xmInfo.yjcs = data.yjcxs + '';
        this.xmInfo.wjcs = data.wjcxs + '';
      }
      this.$refs.xmInfo.init();
    }
  },
  created () {
    this.xmId = this.$route.params.xmId;
    this.importUrl = this.$config.ctx.iffApi + `/xfjc/jcsb/${this.xmId}/import`;
  }
};
</script>

<style>

</style>
